import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Skeleton,
} from "@mui/material";
import React from "react";
import {
  Assignment,
  Cancel,
  CheckCircle,
  CurrencyRupee,
  Warning,
} from "@mui/icons-material";
import { displayPriceFormat } from "../../helpers/convertPrice";

interface AnalyticsData {
  totalComplaints: number;
  totalComplaintCancelled: number;
  totalComplaintsClosed: number;
  totalComplaintsOpen: number;
}

interface AnalyticsCardProps {
  data?: AnalyticsData;
  loading?: boolean;
  amount?:string
}

export const AnalyticsCard: React.FC<AnalyticsCardProps> = ({
  data,
  loading = false,
  amount
}) => {
  const analyticsItems = [
    {
      title: "Earned Amount",
      value: "₹" + displayPriceFormat(Number(amount)) || 0,
      icon: <CurrencyRupee />,
      color: "#1976d2",
      bgColor: "#e3f2fd",
    },
    {
      title: "Total Complaints",
      value: data?.totalComplaints || 0,
      icon: <Assignment />,
      color: "#1976d2",
      bgColor: "#e3f2fd",
    },
    {
      title: "Open Complaints",
      value: data?.totalComplaintsOpen || 0,
      icon: <Warning />,
      color: "#f57c00",
      bgColor: "#fff3e0",
    },
    {
      title: "Closed Complaints",
      value: data?.totalComplaintsClosed || 0,
      icon: <CheckCircle />,
      color: "#388e3c",
      bgColor: "#e8f5e8",
    },
    {
      title: "Cancelled Complaints",
      value: data?.totalComplaintCancelled || 0,
      icon: <Cancel />,
      color: "#d32f2f",
      bgColor: "#ffebee",
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {analyticsItems.map((item, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
              },
            }}
          >
            <CardContent sx={{ p: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 1,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: item.bgColor,
                    borderRadius: "50%",
             
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      color: item.color,
                      fontSize: "1.5rem",
                    }}
                  >
                    {item.icon}
                  </Box>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 700,
                      color: item.color,
                      lineHeight: 1,
                    }}
                  >
                    {loading ? (
                      <Skeleton variant="text" width={60} />
                    ) : (
                      item.value.toLocaleString()
                    )}
                  </Typography>
                </Box>
              </Box>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontWeight: 500,
                  fontSize: "0.875rem",
                }}
              >
                {item.title}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
